import styled from '@emotion/styled';
import Link from '@ep/components/Link';
import Media from '@ep/components/Media';
import SeeMoreLink from '@ep/components/SeeMoreLink';
import { Body2, Body3, H4 } from '@ep/components/Typography';
import theme from '@ep/theme';
import { Gcms_Post } from '@ep/types/gatsbyTypes';
import wordLibrary from '@ep/utils/topicsAndTags';
import truncate from '@ep/utils/truncate';
import { DateTime } from 'luxon';
import React from 'react';
export interface PostCardProps {
  post: Gcms_Post;
}

const StyledMedia = styled(Media)`
  width: 100%;

  ${theme.mediaQueries.desktop} {
  }

  ${theme.mediaQueries.mobileAndTablet} {
    margin-top: 3rem;
    width: 100%;
  }
`;

const StyledH4 = styled(H4)`
  text-align: left;
  padding-left: 1rem;
  margin-top: 1rem;
  color: ${theme.colors.duskBlue};
`;

const StyledBody3 = styled(Body3)`
  text-align: left;
  padding-left: 1rem;
  margin-bottom: 1rem;
`;

const StyledBody2 = styled(Body2)`
  padding-left: 1rem;
  text-align: left;
`;

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  ${theme.mediaQueries.desktop} {
    flex: 1;
  }
`;

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  margin: 0.5rem 0.5rem;
  box-shadow: 2px 2px 6px ${theme.colors.darkGray};
  background-color: ${theme.colors.white};
  padding: 0.75rem;

  ${theme.mediaQueries.mobileAndTablet} {
    width: 90%;
  }
`;

const CardFooter = styled.div`
  margin-top: auto;
  padding-top: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const StyledSeeMoreLink = styled(SeeMoreLink)`
  margin: auto 0;
  white-space: nowrap;
`;

const TitleLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`;

function PostCard({ post }: PostCardProps) {
  const currentUrl =
    typeof window !== 'undefined' ? window.location.pathname : '';

  let postTopicPretty: string = '';
  if (post.postTopic) {
    postTopicPretty = wordLibrary[post.postTopic as keyof typeof wordLibrary];
  }

  return (
    <StyledCard>
      <Link to={'/' + post.slug} state={{refferer:currentUrl}}>
        <StyledMedia media={post.featuredImage!} aspectRatio={1} cover />
      </Link>
      <Texts>
        {post && !post.hideTitle && (
          <TitleLink to={'/' + post.slug} state={{refferer:currentUrl}}>
            <StyledH4>{post.title}</StyledH4>
          </TitleLink>
        )}
        <StyledBody3>
          {DateTime.fromISO(post.displayDate).toLocaleString(
            DateTime.DATE_SHORT,
          )}
        </StyledBody3>
        <StyledBody2>{truncate(post.description, 106)}</StyledBody2>
        <CardFooter>
          {post.postType != 'UK_Casting' ? (
          <StyledBody2>
            <>
              <strong>Topic: </strong>
              <a
                href={
                  post.postType === 'In_The_News' ||
                  post.postType === 'Press_Release'
                    ? '/newsroom/?topic=' + post.postTopic
                    : '/' +
                      post.postType.toLowerCase().replace(/_/g, '-') +
                      '/?topic=' +
                      post.postTopic
                }
              >
                {postTopicPretty
                  ? postTopicPretty
                  : post.postTopic.replace(/_/g, ' ')}
              </a>
            </>
          </StyledBody2>
          ) : <StyledBody2/> }
          <StyledSeeMoreLink
            to={'/' + post.slug}
            label={post.postType != 'Master_Series' ? 'More' : 'Watch'}
            state={{refferer:currentUrl}}
          />
        </CardFooter>
      </Texts>
    </StyledCard>
  );
}

export default PostCard;
